import { Capacitor } from "@capacitor/core"
import { Badge } from "@capawesome/capacitor-badge"

const isNative = Capacitor.isNativePlatform()

class AppIconBadgeService {
    private initialized = false

    async initialize() {
        if (!isNative || this.initialized) {
            return
        }

        try {
            const permissions = await Badge.checkPermissions()
            if (permissions.display === "prompt") {
                await Badge.requestPermissions()
            }

            this.initialized = true
        } catch (error) {
            console.warn("Failed to initialize app icon badge support", error)
        }
    }

    async setCount(count: number) {
        if (!isNative) {
            return
        }

        const normalizedCount = Math.max(0, Math.floor(count))

        try {
            if (normalizedCount === 0) {
                await Badge.clear()
                return
            }

            await Badge.set({ count: normalizedCount })
        } catch (error) {
            console.warn("Failed to update app icon badge", error)
        }
    }
}

export const appIconBadgeService = new AppIconBadgeService()
